<script module lang="ts">
	export interface BaseParagraphProps {
		token: Tokens.Paragraph | Tokens.Blockquote;
		options: MarkdownOptions | undefined;
		renderers: Renderers | undefined;
	}
</script>

<script lang="ts">
	import type { MarkdownOptions, Renderers } from '@magidoc/plugin-svelte-marked';
	import type { Tokens } from 'marked';
	import { twMerge } from 'tailwind-merge';
	import { Txt, type TxtVariant } from '../../../../Txt';
	import { MarkdownInlineTokens } from '../../MarkdownInlineTokens';

	interface Props {
		token: Tokens.Paragraph | Tokens.Blockquote;
		variant: TxtVariant;
		boldVariant: TxtVariant;
		options: MarkdownOptions | undefined;
		renderers: Renderers | undefined;
		class?: string | undefined;
	}

	let { options, renderers, ...props }: Props = $props();
</script>

<Txt class={twMerge('mb-6', props.class)} variant={props.variant}>
	<MarkdownInlineTokens
		variant={props.variant}
		class={props.class}
		boldVariant={props.boldVariant}
		tokens={props.token.tokens}
		{options}
		{renderers}
	/>
</Txt>
